import dynamic from "next/dynamic";

import { useCallback, useEffect, useState } from "react";

import { NextPage } from "next";

import Hero from "sections/nfcTagsPage/Hero";
import TabsSection from "sections/nfcTagsPage/TabsSection";
import ProductSection from "sections/nfcTagsPage/ProductSection";
import FeaturesSection from "sections/nfcTagsPage/FeaturesSection";
import OpportunitiesSection from "sections/nfcTagsPage/OpportunitiesSection";
import BridgeSection from "sections/nfcTagsPage/BridgeSection";
import AppSection from "sections/nfcTagsPage/AppSection";
import ReviewsSection from "sections/nfcTagsPage/ReviewsSection";
import ContactSection from "sections/nfcTagsPage/ContactSection";

const DiscoverySection = dynamic(
  import("sections/nfcTagsPage/DiscoverySection"),
  {
    ssr: false,
  },
);

const ProcessSection = dynamic(import("sections/nfcTagsPage/ProcessSection"), {
  ssr: false,
});

import Layout from "components/Layout";

const NfcPinsPage: NextPage = () => {
  /*
    We have two sections which use gsap with ScrollTrigger. This plugin calculates everything in useEffect
    hook (onMounted). Sometimes the calculations are outdated, because something in previous sections had loaded.
    So we wait until all assets are loaded to make calculations.
  */
  const [loadingStep, setLoadingStep] = useState(0);

  const increaseLoadingStep = useCallback(() => {
    setLoadingStep((prevState) => prevState + 1);
  }, []);

  useEffect(() => {
    const handler = (event) => {
      if (event.target.readyState === "complete") {
        increaseLoadingStep();
      }
    };

    if (loadingStep !== 0) {
      return () => {
        window.removeEventListener("readystatechange", handler);
      };
    }

    if (document.readyState === "complete") {
      increaseLoadingStep();
      return () => {
        window.removeEventListener("readystatechange", handler);
      };
    }

    document.addEventListener("readystatechange", handler);

    return () => {
      window.removeEventListener("readystatechange", handler);
    };
  }, [increaseLoadingStep, loadingStep]);

  return (
    <Layout>
      <Hero
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
      />
      <TabsSection
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
      />
      <ProductSection
        boxProps={{
          mb: { xs: 12, md: 22, lg: 26 },
        }}
      />
      <DiscoverySection
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
        setSectionLoaded={increaseLoadingStep}
        isReadyToStart={loadingStep === 1}
      />
      <FeaturesSection
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
      />
      <OpportunitiesSection
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
      />
      <BridgeSection
        boxProps={{
          mb: { xs: 10, lg: 16 },
        }}
      />
      <AppSection
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
      />
      <ProcessSection
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
        setSectionLoaded={increaseLoadingStep}
        isReadyToStart={loadingStep === 2}
      />
      <ReviewsSection
        boxProps={{
          mb: { xs: 12, lg: 16 },
        }}
      />
      <ContactSection />
    </Layout>
  );
};

export default NfcPinsPage;
